/* eslint-disable no-unused-vars */
import React, { FunctionComponent, ReactNode, useState, useEffect } from 'react';
import InputMask from 'react-input-mask';


interface IFormatter {
  [key: string]: string;
}

export interface ITimeInput {
  id?: string;
  name?: string;
  value?: string | undefined;
  formatChars?: IFormatter;
  mask?: string | (string | RegExp)[];
  maskChar?: string;
  label?: string | ReactNode;
  placeholder?: string;
  className?: string;
  children?: any;
  onChange?: (value: string) => void;
  t?: (key: string, defaultValue: string) => string;
}

const defaultFormatter = (value: string | undefined): IFormatter => ({
  h: '[0-2]',
  m: '[0-5]',
  H: value && value[0] === '2' ? '[0-3]' : '[0-9]',
  9: '[0-9]',
});
const defaultProps: ITimeInput = {
  label: 'Enter time',
  mask: 'hH:m9',
  maskChar: ' ',
  placeholder: 'HH:MM',
  t: key => key,
};

export const TimeInput: FunctionComponent<ITimeInput> = ({
  name,
  formatChars,
  value,
  mask,
  label,
  className,
  children,
  onChange,
  t,
  ...props
}: ITimeInput) => {
  const [currentValue, setCurrentValue] = useState(value);
  const formatter = defaultFormatter(currentValue);

  const handleChange = (e: any) => {
    if (onChange) onChange(e.target.value);
  };

  useEffect(() => {
    setCurrentValue(value);
    return () => {
      setCurrentValue('00:00');
    };
  }, [value]);

  return (
    <>
      {label && (
        <label id={`${label}`} className="text-muted" htmlFor={name}>
          {label}
        </label>
      )}
      <InputMask
        // @ts-ignore
        mask={mask}
        name={name}
        id={props.id || name}
        formatChars={formatChars || formatter}
        className={`form-control text-center ${className || ''}`}
        {...props}
        aria-labelledby={`${label}`}
        value={currentValue}
        onChange={handleChange}
      >
        {children}
      </InputMask>
    </>
  );
};
TimeInput.defaultProps = defaultProps;

export default TimeInput;
